












































































import { Component, Prop, Vue } from "vue-property-decorator";
import DoKoBtn from "../../controls/DoKoBtn.vue";

import { Action, Getter } from "vuex-class";
import { api as deskApi } from "../../../store/modules/desk";
import {
  GameState,
  ItemRef,
  PossibleRestriction,
  Restriction,
} from "@dokogd/shared";

@Component({ components: { DoKoBtn } })
export default class DoKoRestrictionOverview extends Vue {
  readonly DISABLED_STYLE = {
    cursor: "default",
    opacity: 0.4,
  };

  @Getter(deskApi.getters.getPossibleRestrictions, {
    namespace: deskApi.namespace,
  })
  possibleRestrictions!: PossibleRestriction[];

  @Getter(deskApi.getters.getLeadPlayer, {
    namespace: deskApi.namespace,
  })
  leadPlayer!: null | ItemRef;

  get hasPoverty() {
    console.log("possibleRestrictions", this.possibleRestrictions);
    return this.possibleRestrictions.includes("poverty");
  }
  get povertyStyle() {
    return this.hasPoverty ? {} : this.DISABLED_STYLE;
  }

  get hasWedding() {
    return this.possibleRestrictions.includes("wedding");
  }
  get weddingStyle() {
    return this.hasWedding ? {} : this.DISABLED_STYLE;
  }

  selected(componentName: string) {
    this.$emit("select", componentName);
  }
}
